import { lazy } from "react";
import store from "@redux/store";
import { BRAND_LIST, COUNTRY } from "@type/index";
import { isPC, replacePlaceholder } from "@util/helpers";

const DynamicComponent = lazy(() => {
  const { brand_name, region } = store.getState().config;
  const UQHK_STG_DOMAIN_PC = "stg-ext-pc.uniqlo.com.hk";
  const UQHK_STG_DOMAIN_H5 = "stg-ext-h5.uniqlo.com.hk";
  const UQHK_PRD_DOMAIN_PC = "www.uniqlo.com.hk";
  const UQHK_PRD_DOMAIN_H5 = "m.uniqlo.com.hk";

  // staging domain
  const stgDomainSwitch = () => {
    switch (`${brand_name}${region}`) {
      // UQTW & GUTW & GUHK
      case `${BRAND_LIST.UQ}${COUNTRY.TW}`:
      case `${BRAND_LIST.GU}${COUNTRY.TW}`:
      case `${BRAND_LIST.GU}${COUNTRY.HK}`: {
        if (
          !isPC(brand_name, region) &&
          window.location.origin.indexOf("pc") > 0
        ) {
          const origin = replacePlaceholder(window.location.origin, {
            pc: "h5"
          });
          const url = `${origin}${window.location.pathname}${window.location.search}`;
          window.location.replace(url);
        } else if (
          isPC(brand_name, region) &&
          window.location.origin.indexOf("h5") > 0
        ) {
          const origin = replacePlaceholder(window.location.origin, {
            h5: "pc"
          });
          const url = `${origin}${window.location.pathname}${window.location.search}`;
          window.location.replace(url);
        }
        break;
      }

      // UQHK
      case `${BRAND_LIST.UQ}${COUNTRY.HK}`: {
        const currentDomain = window.location.hostname;
        // new STG env
        if (
          currentDomain === UQHK_STG_DOMAIN_PC ||
          currentDomain === UQHK_STG_DOMAIN_H5
        ) {
          if (
            !isPC(brand_name, region) &&
            currentDomain === UQHK_STG_DOMAIN_PC
          ) {
            const origin = replacePlaceholder(window.location.origin, {
              [UQHK_STG_DOMAIN_PC]: UQHK_STG_DOMAIN_H5
            });
            const url = `${origin}${window.location.pathname}${window.location.search}`;
            window.location.replace(url);
          } else if (
            isPC(brand_name, region) &&
            currentDomain === UQHK_STG_DOMAIN_H5
          ) {
            const origin = replacePlaceholder(window.location.origin, {
              [UQHK_STG_DOMAIN_H5]: UQHK_STG_DOMAIN_PC
            });
            const url = `${origin}${window.location.pathname}${window.location.search}`;
            window.location.replace(url);
          }
        } else if (
          !isPC(brand_name, region) &&
          window.location.origin.indexOf("h5") === -1
        ) {
          const origin = replacePlaceholder(window.location.origin, {
            "co-": "co-h5"
          });
          const url = `${origin}${window.location.pathname}${window.location.search}`;
          window.location.replace(url);
        } else if (
          isPC(brand_name, region) &&
          window.location.origin.indexOf("h5") > 0
        ) {
          const origin = replacePlaceholder(window.location.origin, {
            "co-h5": "co-"
          });
          const url = `${origin}${window.location.pathname}${window.location.search}`;
          window.location.replace(url);
        }
        break;
      }
      default:
        break;
    }
  };

  // production
  const prodDomainSwitch = () => {
    switch (`${brand_name}${region}`) {
      // GUHK & UQTW & GUTW
      case `${BRAND_LIST.GU}${COUNTRY.HK}`:
      case `${BRAND_LIST.UQ}${COUNTRY.TW}`:
      case `${BRAND_LIST.GU}${COUNTRY.TW}`: {
        if (
          !isPC(brand_name, region) &&
          window.location.origin.indexOf("www.") > 0
        ) {
          const origin = replacePlaceholder(window.location.origin, {
            "www.": "m."
          });
          const url = `${origin}${window.location.pathname}${window.location.search}`;
          window.location.replace(url);
        } else if (
          isPC(brand_name, region) &&
          window.location.origin.indexOf("m.") > 0
        ) {
          const origin = replacePlaceholder(window.location.origin, {
            "m.": "www."
          });
          const url = `${origin}${window.location.pathname}${window.location.search}`;
          window.location.replace(url);
        }
        break;
      }
      // UQHK
      case `${BRAND_LIST.UQ}${COUNTRY.HK}`: {
        const currentDomain = window.location.hostname;
        if (!isPC(brand_name, region) && currentDomain === UQHK_PRD_DOMAIN_PC) {
          const origin = replacePlaceholder(window.location.origin, {
            [UQHK_PRD_DOMAIN_PC]: UQHK_PRD_DOMAIN_H5
          });
          const url = `${origin}${window.location.pathname}${window.location.search}`;
          window.location.replace(url);
        } else if (
          isPC(brand_name, region) &&
          currentDomain === UQHK_PRD_DOMAIN_H5
        ) {
          const origin = replacePlaceholder(window.location.origin, {
            [UQHK_PRD_DOMAIN_H5]: UQHK_PRD_DOMAIN_PC
          });
          const url = `${origin}${window.location.pathname}${window.location.search}`;
          window.location.replace(url);
        }
        break;
      }
      default:
        break;
    }
  };

  if (process.env.REACT_APP_ENV === "staging") {
    stgDomainSwitch();
  } else {
    prodDomainSwitch();
  }

  switch (brand_name) {
    case BRAND_LIST.UQ:
      return import("../UQLayout");
    case BRAND_LIST.GU:
      return import("../GULayout");
    default:
      return import("../GULayout");
  }
});

export default DynamicComponent;
